export interface Review {
  image: string
  name: string
  age: number
  location: string
  rating: number
  timeline: string
  review: string
}

export const crownControlReviews: Review[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/4ZLXWipG3jyReFdVsh6mid/Background.png',
    name: 'Robert M.',
    age: 42,
    location: 'Seattle, WA',
    rating: 5,
    timeline: '6 months',
    review:
      "I was skeptical about another 'miracle device,' but the science made sense. Six months in, my crown has noticeably filled in. My wife noticed before I did. The best part? No side effects, no pills, just 10 minutes a day. Wish I'd started this two years ago.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/e8iH4uv17vF7JgFu1cWxzW/Background-1.png',
    name: 'Michael K.',
    age: 35,
    location: 'Phoenix, AZ',
    rating: 5,
    timeline: '5 months',
    review:
      "After trying finasteride and dealing with the side effects, I was ready to just accept it. CrownControl gave me another option. Five months of consistent use and my hairline has stabilized. I'm seeing new growth at the temples. Finally something that works without messing with my hormones.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/jGZsuyfNBC2s6N7mbAwcsq/Background-1-1.png',
    name: 'David L.',
    age: 39,
    location: 'Boston, MA',
    rating: 5,
    timeline: '7 months',
    review:
      "The progress photos don't lie. Seven months ago, my crown was thinning badly. Now there's real density there. I use it while I'm working from home—completely hands-free. The 180-day guarantee gave me confidence to try it. Best decision I've made for my hair.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/19RBsyZx1kmCp9NxZuxjvC/Background-2.png',
    name: 'Jennifer T.',
    age: 44,
    location: 'Austin, TX',
    rating: 5,
    timeline: '6 months',
    review:
      "I bought this for my husband after watching him stress about his thinning hair for years. He was hesitant at first, but the results speak for themselves. Six months later, his hair looks fuller and healthier. He's more confident, and I'm grateful we found something that actually works.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/hBy9ZK7onjZfuP1MGTNRav/Background-2-1.png',
    name: 'Thomas R.',
    age: 37,
    location: 'Denver, CO',
    rating: 5,
    timeline: '8 months',
    review:
      "Eight months of consistent use, and I can finally say I'm seeing real regrowth. The hairline that was receding is now filling back in. No transplant needed. No hormonal drugs. Just a device that does what it promises. The photo tracking helped me see the progress I couldn't notice day-to-day.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tWQQt3bu6M7M7KhXoswvDW/Background-3.png',
    name: 'Steven P.',
    age: 41,
    location: 'Chicago, IL',
    rating: 5,
    timeline: '6 months',
    review:
      "I'd been losing hair for five years and tried everything—expensive shampoos, supplements, you name it. Nothing worked until CrownControl. Six months later, my temples are filling back in and the crown is noticeably thicker. My barber even commented on it. This is the real deal.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/xfcS3T1nZdwfbxiLSEJY3z/Background-3-1.png',
    name: 'Brian H.',
    age: 38,
    location: 'Portland, OR',
    rating: 5,
    timeline: '7 months',
    review:
      'The crown area was my biggest concern. After seven months with CrownControl, the difference is night and day. I can actually see my scalp filling in with new hair. The consistency is key—I use it every other day without fail. Worth every penny.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/mpnSsstsFNfVjycEZd1VQo/Background-4.png',
    name: 'Christopher J.',
    age: 36,
    location: 'Miami, FL',
    rating: 5,
    timeline: '5 months',
    review:
      "I was three months away from booking a hair transplant consultation. Decided to try this first based on the clinical studies. Five months in, I've cancelled that consultation. My hairline is coming back naturally. No surgery, no downtime, no risk. Just results.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/18sifF9gfJQqQVQU7kED2m/Background-4-1.png',
    name: 'Andrew S.',
    age: 43,
    location: 'San Diego, CA',
    rating: 5,
    timeline: '8 months',
    review:
      "Eight months ago, I was avoiding photos and constantly checking my crown in every mirror. Now I'm confident again. The thinning has reversed, and I'm seeing genuine regrowth. My only regret is not finding CrownControl sooner. The non-hormonal approach was exactly what I needed.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/etZwoCFkqJRFQ6Jxa3xpVo/Background-5.png',
    name: 'Patrick W.',
    age: 40,
    location: 'Nashville, TN',
    rating: 5,
    timeline: '6 months',
    review:
      "The frontal hairline was receding fast. I tried minoxidil but couldn't deal with the daily application. CrownControl is so much easier—just wear it while watching TV. Six months later, the hairline has stabilized and I'm seeing new growth. Finally something that fits my lifestyle and actually works.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/6s8c8y3x56qaxKTr5fyRue/Background-6.png',
    name: 'Rachel S.',
    age: 39,
    location: 'Minneapolis, MN',
    rating: 5,
    timeline: '7 months',
    review:
      'As a woman dealing with hair thinning, I felt like I had limited options. CrownControl changed that. Seven months in, my part line is filling in beautifully. I can finally wear my hair down with confidence again. The device is discreet and easy to use—I wear it while doing household tasks.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/mdYqChcafkbYfjv7XmjDSU/Background-7.png',
    name: 'Gregory N.',
    age: 45,
    location: 'Dallas, TX',
    rating: 5,
    timeline: '9 months',
    review:
      "Nine months ago, my crown was almost completely bald. I'd accepted it was over. But CrownControl proved me wrong. The density has returned in a way I didn't think was possible. The before and after photos are shocking even to me. This device gave me back something I thought was gone forever.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/iMP8AXMJPC7db2heet3ocp/Background-7-1.png',
    name: 'Kevin D.',
    age: 34,
    location: 'Atlanta, GA',
    rating: 5,
    timeline: '6 months',
    review:
      "I'm in my mid-30s and was losing hair fast. CrownControl stopped the progression and reversed it. Six months later, my hairline looks like it did five years ago. The best part? No pills, no side effects, no stress. Just consistent use and real results.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/jFgqYP7E8o5TSRQndqDAk7/Background-8.png',
    name: 'William T.',
    age: 66,
    location: 'Philadelphia, PA',
    rating: 5,
    timeline: '8 months',
    review:
      "At 66, I thought my hair loss days were behind me—that I'd just live with it. CrownControl proved that wrong. Eight months of use and my crown has filled in dramatically. My colleagues have noticed but are too polite to ask. I'm happy to tell them—this device works.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/s7CmaYBry2NyXz4vCKwuXK/Background-8-1.png',
    name: 'Eric M.',
    age: 36,
    location: 'Las Vegas, NV',
    rating: 5,
    timeline: '7 months',
    review:
      "The temple recession was getting bad. I tried everything—minoxidil, biotin, expensive shampoos. Nothing worked until CrownControl. Seven months later, the temples are filling back in with real, thick hair. The device is easy to use and the results speak for themselves. Best investment I've made.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/wvnmWafXucLQwNNA6p9uuc/Background-23.png',
    name: 'Laura K.',
    age: 42,
    location: 'Sacramento, CA',
    rating: 5,
    timeline: '8 months',
    review:
      'As a woman in my 40s, hair thinning was devastating. I tried supplements and special shampoos with no results. CrownControl was different. Eight months later, my crown has filled in beautifully. The density is back, and I feel like myself again. This device gave me back my confidence.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tfddPFjpSXWskMM6Hr48u2/Background-24.png',
    name: 'Jonathan P.',
    age: 39,
    location: 'Charlotte, NC',
    rating: 5,
    timeline: '7 months',
    review:
      'The crown thinning was progressing fast. I researched every option and CrownControl had the best science behind it. Seven months of consistent use and the results are undeniable. My crown has filled in with thick, healthy hair. No side effects, no hassle, just real regrowth.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/ro2odLo88zVFUB3i1YAzWm/Background-25.png',
    name: 'Marcus H.',
    age: 44,
    location: 'Houston, TX',
    rating: 5,
    timeline: '9 months',
    review:
      "Nine months ago, my crown was severely thinned out. I'd tried finasteride but couldn't handle the side effects. CrownControl gave me a hormone-free alternative that actually works. The density has returned, and I'm seeing continued improvement. This is the solution I'd been searching for.",
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/k8oNMox8hE4FGBFNpQGUkZ/Background-26.png',
    name: 'Sarah M.',
    age: 37,
    location: 'Portland, ME',
    rating: 5,
    timeline: '6 months',
    review:
      'Female pattern hair loss runs in my family, and I was terrified of losing my hair. CrownControl has been a game-changer. Six months in, my part line is so much fuller. I can style my hair without worrying about visible scalp. The device is easy to use and the results are incredible.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/ithts7AwRUM51zJBn8aGdf/Background-27.png',
    name: 'Daniel F.',
    age: 41,
    location: 'Tampa, FL',
    rating: 5,
    timeline: '8 months',
    review:
      "The temple recession was making me look older than I felt. Eight months with CrownControl and the temples are filling back in with real hair. The transformation is remarkable. I use it while reading before bed—completely effortless. Best decision I've made for my appearance.",
  },
]
